/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../../utils/Functions';
import { params } from '../../../../../../redux/reducers/reducer';
import WindowModel from './WindowModel';
import HandleOneModel from '../../../ShareModel/HandleModel/HandleOneModel';
import PatternOneModel from '../../../ShareModel/PatternModel/PatternOneModel';

const NineLiteXPatternWalkInDoor = ({ width, height, trimWidth, doorColor, glassTexture, handlePlacement, handleModel }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])

    
    const doorWidth = width - trimWidth * 2
    const doorHeight = height - trimWidth    
    const unitCountX = 20;
    const unitCountY = 30;
    const unitWidth = doorWidth / unitCountX;
    const unitHeight = doorHeight / unitCountY;
    const marginX = unitWidth * 3;
    const holeDistanceX = unitWidth * 3
    const holeWidth = (doorWidth - marginX * 2 - holeDistanceX) / 2;    
    const marginY = unitHeight * 3
    const holeDistanceY = unitHeight * 2.5
    const smallHoleHeight = (doorHeight - marginY * 2 - holeDistanceY * 2) / 7
    const largeHoleHeight = smallHoleHeight * 3
    const windowWidth = doorWidth - marginX * 2;
    const windowHeight = doorHeight - marginY * 2 - holeDistanceY - largeHoleHeight;
    
    const trimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth,  -height / 2);
        model.lineTo(-width / 2,  -height / 2);
        model.lineTo(-width / 2,  height / 2);
        model.lineTo(width / 2,  height / 2);
        model.lineTo(width / 2,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  -height / 2);
        model.lineTo(width / 2 - trimWidth,  height / 2 - trimWidth);
        model.lineTo(-width / 2 + trimWidth,  height / 2 - trimWidth);
        model.closePath();
        
        return model
    }, [width, height, trimWidth])

    const doorModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(width / 2 - 0.03) + trimWidth,  (height / 2 - 0.03) - trimWidth);
        model.lineTo(-(width / 2 - 0.03) + trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  -(height / 2 - 0.03));
        model.lineTo((width / 2 - 0.03) - trimWidth,  (height / 2 - 0.03) - trimWidth);
        
        const holeWindow = new THREE.Path();
        holeWindow.moveTo(-windowWidth / 2, height / 2 - trimWidth - marginY - windowHeight);
        holeWindow.lineTo(-windowWidth / 2, height / 2 - trimWidth - marginY);
        holeWindow.lineTo(windowWidth / 2, height / 2 - trimWidth - marginY);
        holeWindow.lineTo(windowWidth / 2, height / 2 - trimWidth - marginY - windowHeight);
        holeWindow.closePath();

        model.holes.push(holeWindow);

        // for (let i = 0; i < 2; i ++) {
        //     const hole_under = new THREE.Path();
        //     hole_under.moveTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY);
        //     hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2),                -height / 2 + marginY + largeHoleHeight);
        //     hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY + largeHoleHeight);
        //     hole_under.lineTo(Math.pow(-1, i) * (holeDistanceX / 2 + holeWidth),    -height / 2 + marginY);
        //     hole_under.closePath();

        //     model.holes.push(hole_under);
        // }

        const drawWidth = doorWidth - marginX * 2;
        const triangleWidth = drawWidth * (2 / 3);
      
        const path = new THREE.Path();
        path.moveTo( -triangleWidth/2, -height / 2 + marginY + largeHoleHeight);
        path.lineTo(triangleWidth/2, -height / 2 + marginY + largeHoleHeight);
        path.lineTo(0, -height / 2 + marginY + largeHoleHeight - triangleWidth/2);
        path.closePath();
        model.holes.push(path);
    

        const path1 = new THREE.Path();
        path1.moveTo( -triangleWidth/2, -height / 2 + marginY);
        path1.lineTo(triangleWidth/2, -height / 2 + marginY);
        path1.lineTo(0, -height / 2 + marginY + triangleWidth/2);
        path1.closePath();
        model.holes.push(path1);

        const path2 = new THREE.Path();
        path2.moveTo( holeDistanceX / 2 + holeWidth, -height / 2 + marginY + largeHoleHeight/2 - triangleWidth/2);
        path2.lineTo( holeDistanceX / 2 + holeWidth, -height / 2 + marginY + largeHoleHeight/2 + triangleWidth/2);
        path2.lineTo(holeDistanceX / 2 + holeWidth - triangleWidth/2, -height / 2 + marginY + largeHoleHeight/2);
        path2.closePath();
        model.holes.push(path2);

        const path3 = new THREE.Path();
        path3.moveTo(-holeDistanceX / 2 - holeWidth, -height / 2 + marginY + largeHoleHeight/2 - triangleWidth/2);
        path3.lineTo(-holeDistanceX / 2 - holeWidth, -height / 2 + marginY + largeHoleHeight/2 + triangleWidth/2);
        path3.lineTo(-holeDistanceX / 2 - holeWidth + triangleWidth/2, -height / 2 + marginY + largeHoleHeight/2);
        path3.closePath();
        model.holes.push(path3);


        const deviation = 0.15;
        const patternModel = [];
        const shape = new THREE.Shape();
        shape.moveTo( -triangleWidth/2 + deviation, -height / 2 + marginY + largeHoleHeight - deviation/2);
        shape.lineTo(triangleWidth/2 - deviation, -height / 2 + marginY + largeHoleHeight - deviation/2);
        shape.lineTo(0, -height / 2 + marginY + largeHoleHeight - triangleWidth/2 + deviation);
        shape.closePath();
        patternModel.push(shape);

        const shape2 = new THREE.Shape();
        shape2.moveTo( -triangleWidth/2 + deviation, -height / 2 + marginY + deviation/2);
        shape2.lineTo(triangleWidth/2 - deviation, -height / 2 + marginY + deviation/2);
        shape2.lineTo(0, -height / 2 + marginY + triangleWidth/2 - deviation);
        shape2.closePath();
        patternModel.push(shape2);

        const shape3 = new THREE.Shape();
        shape3.moveTo( holeDistanceX / 2 + holeWidth - deviation/2, -height / 2 + marginY + largeHoleHeight/2 - triangleWidth/2 + deviation);
        shape3.lineTo( holeDistanceX / 2 + holeWidth - deviation/2, -height / 2 + marginY + largeHoleHeight/2 + triangleWidth/2 - deviation);
        shape3.lineTo(holeDistanceX / 2 + holeWidth - triangleWidth/2 + deviation, -height / 2 + marginY + largeHoleHeight/2);
        shape3.closePath();
        patternModel.push(shape3);

        const shape4 = new THREE.Shape();
        shape4.moveTo(-holeDistanceX / 2 - holeWidth + deviation/2, -height / 2 + marginY + largeHoleHeight/2 - triangleWidth/2 + deviation);
        shape4.lineTo(-holeDistanceX / 2 - holeWidth + deviation/2, -height / 2 + marginY + largeHoleHeight/2 + triangleWidth/2 - deviation);
        shape4.lineTo(-holeDistanceX / 2 - holeWidth + triangleWidth/2 - deviation, -height / 2 + marginY + largeHoleHeight/2);
        shape4.closePath();
        patternModel.push(shape4);
        return {door: model, pattern: patternModel};
    
    }, [height, trimWidth, width])

    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[trimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={"#000"} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='door' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel.door, extrudeSettings(0.2, 0.03, 0.03, 0, 2)]} />
                <meshStandardMaterial  color={"#181c1c"} side={THREE.DoubleSide} roughness={0.2} metalness={0.5} toneMapped={false} emissive={'#101010'} />
            </mesh>
            <mesh name='pattern' position={[0, 0, 0.05]}>
                <extrudeGeometry args={[doorModel.pattern, extrudeSettings(0.2, 0.03, 0.23, 0, 2)]} />
                <meshStandardMaterial  color={"#1F1F1F"} side={THREE.DoubleSide} roughness={0.3} metalness={0.5} toneMapped={false}/>
            </mesh>
            <group position={[0, height / 2 - trimWidth - marginY - windowHeight / 2, 0.05]}>
                <WindowModel windowWidth={windowWidth} windowHeight={windowHeight} trimColor={"#000"} doorColor={"#000"} glassTexture={glassTexture}  />
            </group>

            <HandleOneModel handlePlacement={handlePlacement} width={width}  handleModel={handleModel} />
        </>
    )
}

export default NineLiteXPatternWalkInDoor